import { useEffect, useState } from "react";

// ----------------------------------------------------------------------
// Types
// ----------------------------------------------------------------------

export type CookieConsent = {
  analytics: boolean;
  timestamp: string;
  gpc?: boolean;
};

// ----------------------------------------------------------------------
// Constants
// ----------------------------------------------------------------------

export const COOKIE_CONSENT_STORAGE_KEY = "cookie-consent-v1";

// ----------------------------------------------------------------------
// Storage Helpers
// ----------------------------------------------------------------------

export function readCookieConsent(): CookieConsent | null {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as CookieConsent;
  } catch {
    return null;
  }
}

export function writeCookieConsent(next: CookieConsent) {
  try {
    localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(next));
    window.dispatchEvent(
      new CustomEvent("cookie-consent-changed", { detail: next })
    );
  } catch {
    // ignore storage errors
  }
}

// ----------------------------------------------------------------------
// Hook
// ----------------------------------------------------------------------

export function useCookieConsent() {
  const [consent, setConsent] = useState<CookieConsent | null>(() =>
    readCookieConsent()
  );

  useEffect(() => {
    const handler = (e: CustomEvent<CookieConsent>) => setConsent(e.detail);
    window.addEventListener(
      "cookie-consent-changed",
      handler as EventListener
    );
    return () =>
      window.removeEventListener(
        "cookie-consent-changed",
        handler as EventListener
      );
  }, []);

  return consent;
}

